import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';
import { Logo } from '../Logo';
import { H1, Text } from '../Typography';

interface IAuthHeaderProps {
  title: string;
  logo?: any;
  subtitle?: string;
  value?: string;
  onBack?: () => void;
  className?: string;
}

const Layout = styled.header`
  position: relative;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

const StyledLogo = styled(Logo)`
  margin-bottom: ${toRem(theme.space.xl)};
`;

const BackButton = styled.button`
  position: absolute;
  top: ${toRem(-4)};
  left: ${toRem(-11)};
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${toRem(44)};
  height: ${toRem(44)};

  @media (min-width: ${theme.breakpoint.small}px) {
    left: ${toRem(-44)};
  }

  svg {
    fill: ${theme.color.neutral[400]};
    transition: fill ${theme.transition.icon};
  }

  &:hover {
    svg {
      fill: ${theme.color.neutral[800]};
    }
  }
`;

const Value = styled(Text)`
  margin-top: ${toRem(theme.space.xs)};
  font-weight: ${theme.font.weight.semiBold};
  word-break: break-word;
`;

const AuthHeader: React.FC<IAuthHeaderProps> = ({ title, subtitle, value, logo, onBack, className, ...other }) => (
  <Layout className={className} {...other}>
    {onBack && (
      <BackButton onClick={onBack} data-cy="back-button">
        <Icon icon="ArrowLeft" width={20} height={20} />
      </BackButton>
    )}
    {logo || <StyledLogo />}

    <H1 data-cy="title">{title}</H1>
    {subtitle && <Text data-cy="subtitle">{subtitle}</Text>}
    {value && <Value data-cy="value">{value}</Value>}
  </Layout>
);

export default AuthHeader;
